'use client';

import { Typography } from '@workspace/ui/common';
import { cn, getBackgroundClass } from '@workspace/lib';
import { processHeading } from '@workspace/lib/heading-utils';
import { CustomPortableText } from '@workspace/ui/PortableText';
import type { IMultiColumnBannerProps } from './multi-column-banner.types';
import { getMultiColumnBannerAlignmentClass, getGridColumns } from './layout';

export function MultiColumnBanner({ block }: IMultiColumnBannerProps) {
  const { heading, headingTextAlignment, backgroundColor, layoutOptions, textBlocks = [] } = block;
  const { text: resolvedHeadingText } = processHeading(heading);
  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('w-full', backgroundClass)}>
      <section className="md:py-3xl py-xl wrapper mx-auto px-6">
        {/* Main Heading */}
        {resolvedHeadingText && (
          <div className={cn('mb-md md:mb-xl', getMultiColumnBannerAlignmentClass(headingTextAlignment))}>
            <Typography variant="h2" className="" styleVariant="h3">
              {resolvedHeadingText}
            </Typography>
          </div>
        )}

        {/* Text Blocks Grid */}
        {textBlocks && textBlocks.length > 0 && (
          <div className={cn('grid gap-y-sm md:gap-y-lg gap-x-xl', getGridColumns(layoutOptions))}>
            {textBlocks.map((textBlock) => {
              const { text: resolvedTextBlockHeading } = processHeading(textBlock.title);
              return (
                <div key={textBlock._key} className="space-y-2">
                  {/* Text Block Heading */}
                  {resolvedTextBlockHeading && (
                    <Typography variant="h3" styleVariant="h6">
                      {resolvedTextBlockHeading}
                    </Typography>
                  )}

                  {/* Text Block Description */}
                  {textBlock.description && (
                    <div className="prose prose-lg max-w-none font-body">
                      <CustomPortableText value={textBlock.description} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
